export default "__VITE_ASSET__DG15sHoq__"